import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

export default function WidgetDescription(props) {
    const className = 'widget-description mt-1 mb-4 ' + (props.className || '');
    return (
        <Row className={className}>
            <Col>
                {props.children}
            </Col>
        </Row>
    );
}